import {createGlobalStyle} from 'styled-components';

const GlobalStyle = createGlobalStyle`
     html {
    box-sizing: border-box;
    font-size: 10px;
    min-width: 100vw;
    scroll-behavior: smooth;
  }
  *,
  *::before,
  *::after {
    box-sizing: inherit;
  }
  body {
    margin: 0;
    padding: 0;
    font-family: 'Raleway';
    color: #262020;
    overflow-x: hidden;
  }
  button {
    padding: 0;
    cursor: pointer;
    font-family: 'Montserrat';
  }
  p {
    font-size: 1.6rem;
  }
  h1, h2, h3 {
    font-family: 'EB Garamond';
  }
  
  ul {
    padding: 0;
    margin: 0;
  }

  h2 {
    font-size: 3.4rem;
    text-align: center;
    font-weight: 300;
  }
  h2, h3 {
    position: relative;

    &::after {
      content: "";
      position: absolute;
      display: block;
      width: 30%;
      height: 0.25rem;
      bottom: -0.6rem;
      left: 50%;
      transform: translateX(-50%);
      background-color: #DBD643;
    }
  }
`;

export default GlobalStyle